import classNames from "classnames";
import LabeledInfo from "../../common/LabeledInfo";
import styles from "./VerifyPhone.module.css";
import StyledButton from "../../common/buttons/StyledButton";

const strings = {
  lastVerified: "Last Verified",
  lastCaptured: "Last Captured",
  firstCaptured: "First Captured",
  verify: "Verify",
  placeholder: "-",
};

type Props = {
  lastVerified: string;
  lastCaptured: string;
  firstCaptured: string;
  onVerify: () => void;
  className?: string;
  isLoading?: boolean;
  disabled?: boolean;
  buttonLabel?: string;
};

export default function VerifyPhone({
  lastVerified,
  lastCaptured,
  firstCaptured,
  onVerify,
  className,
  isLoading,
  disabled,
  buttonLabel,
}: Props) {
  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.infoContainer}>
        <LabeledInfo
          label={strings.lastVerified}
          value={isLoading ? strings.placeholder : lastVerified}
          orientation="vertical"
        />
        <LabeledInfo
          label={strings.lastCaptured}
          value={lastCaptured}
          orientation="vertical"
        />
        <LabeledInfo
          label={strings.firstCaptured}
          value={firstCaptured}
          orientation="vertical"
        />
      </div>
      <StyledButton
        className={styles.verifyButton}
        variant="secondary"
        onClick={onVerify}
        isLoading={isLoading}
        disabled={disabled}
      >
        {buttonLabel ?? strings.verify}
      </StyledButton>
    </div>
  );
}
